export default __webpack_public_path__ + "static/media/Lady_Finger.8dfe03f6.jpg";